import { api_GET, api_POST } from "./_api.js";

const vistoria_api = {
    GetItem: async (agendamentoId) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Vistoria/GetItem/` + agendamentoId)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },

}

export default vistoria_api;
